export const evidenceFAQs = [];
